module.exports = __webpack_public_path__ + "static/RootSans-11Black-e4cd5b9f5dcfd1f7ad423c9f193a3d02.woff";